import React, { useEffect, useState } from "react";
import { graphql, Link } from "gatsby";
import Layout from "../components/layout";
import { Container, Row, Col, Modal, ModalBody } from "reactstrap";
import SEO from "../components/common/SEO/";
import Hero from "../components/common/Hero/HomeHero";
import Sponsor from "../components/Sponsor";
import Video from "../components/Home/Video";
import ValueProposition from "../components/Home/ValueProposition";
import Venue from "../components/Home/Venue";
import LazyLoad from "react-lazyload";
import { getImage } from "gatsby-plugin-image";
import { BgImage } from "gbimage-bridge";
import CTA from "../components/cta-block";

const Home = ({ data }) => {
  const heroImage = data.heroImage;
  const whyAttendImage = getImage(data.whyAttendImage);

  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  // Load Window after page mounts
  useEffect(() => {
    toggle();
  }, []);

  return (
    <Layout pageId="home">
      <SEO title="Home" />
      <Hero heroImage={heroImage} />
      {/* 
      <Modal isOpen={modal} toggle={toggle} centered={true} size="lg">
        <ModalBody className="p-5">
          <h3>Headline H3</h3>
          <h6 className="py-3">H6 Text Line</h6>
          <h4 className="my-auto" style={{color: "#0085ad"}}>H4 SubHeadline</h4> 
            <h6 className="py-3">lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
            <br></br><br></br>
            This is a <a href="#" target="_blank">CTA</a> statement.
            </h6>
          <div className="d-flex">
            <button className="tertiary-cta" onClick={() => { toggle() }}>Close</button>
            <a className="primary-cta ml-auto" href="#">Register Now</a>
          </div>
        </ModalBody>
      </Modal>
       */}
      <section className="video">
        <Container>
          <Row>
            <Col sm={12} className="text-center mt-5">
              <div>
                <h3>Connect. Learn. Grow.</h3>
                <hr
                  style={{
                    margin: "1rem auto",
                  }}
                />
                <p>
                  The Xylem Reach Conference delivers educational content
                  designed to take you and your utility to the next level.
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col sm={12} className="text-center mt-5">
              <h3>The opportunity to learn is endless.</h3>
              <hr
                style={{
                  margin: "1rem auto",
                }}
              />
              <p>
                The event will feature compelling sessions, educational Learning
                Labs, SPAN business meetings, distributor sessions and more.
                Join us at Marriott Marquis and connect with water, gas and
                electric utility professionals and gain new ways to maximize the
                value of your Xylem technology.
              </p>
            </Col>
            <Col sm={12} className="text-center mt-5">
              <h3>Built for utility professionals across your organization</h3>
              <hr
                style={{
                  margin: "1rem auto",
                }}
              />
              <p
                style={{
                  textAlign: "left",
                }}
              >
                REACH brings together leaders and practitioners from across the
                utility ecosystem:
                <ul>
                  <li>Utility executives and directors</li>
                  <li>Operations and distribution leaders</li>
                  <li>Metering and AMI teams</li>
                  <li>Engineering and asset management professionals</li>
                  <li>Data, analytics, and IT teams</li>
                </ul>
              </p>
            </Col>

            {/* Video Embed <Col xs={12}>
              <CTA ctaId="look-back" />
            </Col> */}
          </Row>
          <Row
            style={{
              marginTop: "3rem",
            }}
          ></Row>
        </Container>
      </section>
      <section className="speedbump why-attend">
        <BgImage
          style={{
            height: "100%",
            width: "100%",
          }}
          image={whyAttendImage}
          className="gatsby-image-wrapper"
        >
          <div className="center">
            <h2>We look forward to seeing you at Reach.</h2>

            <Link className="tertiary-cta" to="/attend/updates/">
              Sign Up for Updates
            </Link>
          </div>
        </BgImage>
      </section>
      {/* <section className="video">
        <Container>
          <Row>
            <Col sm={12}>
              <div
                style={{
                  textAlign: "center",
                  marginTop: "3rem",
                }}
              >
                <h3>Welcome to Houston, Texas</h3>
                <hr
                  style={{
                    margin: "1rem auto",
                  }}
                />
                <p>Join us at the Marriott Marquis Houston</p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <Venue className="py-0" hideIcons={true} />
            </Col>
            <Col
              sm={12}
              style={{
                textAlign: "center",
                marginTop: "0px",
              }}
            >
              <a className="primary-cta" href="/attend/location/">
                Learn More
              </a>
            </Col>
          </Row>
          <Row
            style={{
              marginTop: "3rem",
            }}
          ></Row>
        </Container>
      </section> */}
    </Layout>
  );
};

export default Home;
// Set Global Hero Images
export const pageQuery = graphql`
  query HomeQuery {
    heroImage: file(relativePath: { eq: "HoustonHero.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH)
      }
    }
    whyAttendImage: file(relativePath: { eq: "Reach21-Crowd02.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH)
      }
    }
  }
`;
